export const LOAD_USER = "loadUser"
export const LOGIN = "login"
export const LOGOUT = "logout"
